import * as React from 'react';
import Share from "../share/share";
import './articleFooterCta.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Watch } from 'scrollmonitor-react';

library.add(faArrowRight);

class ArticleFooterCta extends React.Component {

  render() {
    let theBlock = this.props.block;
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
    let localizedUrl = theBlock.blockReportLink;
    let tmpLocationMap = this.props.locationMap[this.props.location.country_code]
    let tempCountryPathCode = "";
    let tempCountryLinkCode = "";
    let tempCountryLangCode = "";    

    if(this.props.locationMap[this.props.location.country_code]) {
        tempCountryPathCode = tmpLocationMap.pathCode ? tmpLocationMap.pathCode : "";
        tempCountryLinkCode = tmpLocationMap.linkCode ? tmpLocationMap.linkCode : "";
        tempCountryLangCode = tmpLocationMap.langCode ? tmpLocationMap.langCode : "";    
    }

    //check values is not empty and set to uk if is.
    tempCountryPathCode = tempCountryPathCode !== "" ? tempCountryPathCode : "UK";
    tempCountryLinkCode = tempCountryLinkCode !== "" ? tempCountryLinkCode : "UK";
    tempCountryLangCode = tempCountryLangCode !== "" ? tempCountryLangCode : "en";

    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change class name based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    localizedUrl = localizedUrl.replace(/{path_code}/g, tempCountryPathCode);
    localizedUrl = localizedUrl.replace(/{link_code}/g, tempCountryLinkCode);
    localizedUrl = localizedUrl.replace(/{lang_code}/g, tempCountryLangCode);

    return (
    <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
        <div className="container"> 
            <div className="row">
                <div className="col-12 mb-sm-4">
                    <div className="row">
                        <div className="col-md-4 offset-md-2">
                            {theBlock.textFirst ? (
                            <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} />
                            ) : (
                            <div className="cta-block">
                                <figure>
                                    <img src={baseUrl+theBlock.blockReportImage} alt={theBlock.blockImageAlt}/>
                                    {theBlock.blockReportCaption ? <figcaption>{theBlock.blockReportCaption}</figcaption> : ""}
                                </figure>
                                <button className='btn btn-primary read-more' data-iframe-href={localizedUrl} onClick={() => {this.props.ctaHandler(localizedUrl)}}>
                                    <span>{theBlock.blockReportText}</span>
                                    <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                                </button>
                            </div>
                            )}
                        </div>
                        <div className="col-md-4 offset-md-1">
                            {theBlock.textFirst ? (
                            <div className="cta-block">
                                <figure>
                                    <img src={baseUrl+theBlock.blockReportImage} alt={theBlock.blockImageAlt}/>
                                    {theBlock.blockReportCaption ? <figcaption>{theBlock.blockReportCaption}</figcaption> : ""}
                                </figure>
                                <button className='btn btn-primary read-more' data-iframe-href={localizedUrl} onClick={() => {this.props.ctaHandler(localizedUrl)}}>
                                    <span>{theBlock.blockReportText}</span>
                                    <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                                </button>
                            </div>
                            ) : (
                            <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} />
                            )}
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-4">
                            <Share/> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

export default Watch(ArticleFooterCta);
